module.exports = __webpack_public_path__ + "assets/img/face_contrast_example5.8ecb2b45.png";